import React from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import CustomTree from 'App/Screens/SubModules/UserGroup/User/Management/Component/CustomTree'
import WarningLabel from '../WarningLabel'
import ErrorLabel from '../ErrorLabel'

class PageJobQueues extends React.PureComponent {
  constructor(props) {
    super(props)

    this.merchantTitles = ['Available Allowed Merchants', 'Chosen Allowed Merchants']
    this.state = {
      errorMessage: '',
    }
  }

  onFieldTouched = (isFieldsTouched) => {
    this.props.onFieldTouched(isFieldsTouched, () => {
      this.setState({ errorMessage: '' })
    })
  }

  validateFields = () => {
    if (get(this._branch, 'validateFields')) {
      return this._branch.validateFields()
    }
    return undefined
  }

  setError = (errorMessage) => {
    this.props.setActiveKey(this.props.tabKey, () => {
      this.setState({ errorMessage })
    })
  }

  render() {
    const { readOnly, groupHelper, group } = this.props
    const { errorMessage } = this.state

    return (
      <div>
        { errorMessage && <ErrorLabel errorMessage={errorMessage} /> }
        <WarningLabel tabName='Job Queues' groupName={get(group, 'name', '')} />
        <div style={{ padding: '12px 24px' }}>
          <CustomTree
            autoExpand
            ref={ref => {this._branch = ref}}
            readOnly={readOnly}
            title='Job Queues'
            dataSource={groupHelper.branch}
            initialValue={get(group, 'branch_queues')}
            setTouched={this.onFieldTouched}
          />
        </div>
      </div>
    )
  }
}

PageJobQueues.propTypes = {
  readOnly: PropTypes.bool,
  tabKey: PropTypes.string,
  groupHelper: PropTypes.object,
  group: PropTypes.object,
  onFieldTouched: PropTypes.func,
  setActiveKey: PropTypes.func,
}

PageJobQueues.defaultProps = {
  readOnly: false,
  tabKey: null,
  groupHelper: { branch: [] },
  group: null,
  onFieldTouched: () => null,
  setActiveKey: (tabKey, callback = () => null) => callback(),
}

export default PageJobQueues